import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { PartialReceiptsItemWithSelected } from '../../models';
import { NOTIFICATIONS_MAP } from '$modules/personal/modules/batch';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AddAttachmentModalComponent } from '$modules/personal/modules/batch/features/batches/modals/add-attachment-modal/add-attachment-modal.component';
import { BehaviorSubject } from 'rxjs';
import { BatchesParseStorageService } from '../../services';
import { BelpostContact } from '$shared/types';

@Component({
  selector: 'app-view-attachments-info',
  templateUrl: './view-attachments-info.component.html',
  styleUrls: ['./view-attachments-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewAttachmentsInfoComponent implements OnDestroy {
  @Input() public activeTab: number;
  @Input() public searchParam: string;
  @Input() public isAttachmentLoading$: BehaviorSubject<boolean>;
  @Output() public batchDeparturesParamsChange: EventEmitter<{
    search: string;
  }> = new EventEmitter();
  @Output() public sendDeletingAttachmentsIds = new EventEmitter<string[]>();

  public readonly faTrashAlt = faTrashAlt;
  public readonly NOTIFICATIONS_MAP = NOTIFICATIONS_MAP;

  public batchDeparture$ = this.batchStorageService.batchDeparture$;
  public batchDepartureAttachments$ =
    this.batchStorageService.batchDepartureAttachments$;

  public get selectedAttachments(): PartialReceiptsItemWithSelected[] {
    return this.batchDepartureAttachments$
      .getValue()
      .filter((attachment) => attachment.selected);
  }

  public get isAllAttachmentsSelected() {
    return this.batchDepartureAttachments$
      .getValue()
      .every((departure) => departure.selected);
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly modalService: BsModalService,
    private readonly batchStorageService: BatchesParseStorageService
  ) {}

  public searchAttachments(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    setTimeout(() => {
      this.batchDeparturesParamsChange.emit({ search: inputElement.value });
    }, 700);
  }

  public selectAllCards() {
    const initialDepartures = this.batchDepartureAttachments$.getValue();

    const updatedAttachments = initialDepartures.map((attachItem) => ({
      ...attachItem,
      selected: !this.isAllAttachmentsSelected,
    }));

    this.batchDepartureAttachments$.next(updatedAttachments);
  }

  public deleteSelectedAttachments() {
    const deletedDeparturesIds = this.batchDepartureAttachments$
      .getValue()
      .filter((departure) => departure.selected)
      .map((item) => item.id);

    this.sendDeletingAttachmentsIds.emit(deletedDeparturesIds);
  }

  public openAddAttachmentModal() {
    this.modalService.show(AddAttachmentModalComponent, {
      initialState: {
        batchId: this.activatedRoute.snapshot.params['id'],
        batchDepartureId: this.batchDeparture$.getValue().id.toString(),
      },
      ignoreBackdropClick: false,
      class: 'modal-dialog-centered modal-lg',
    });
  }

  public selectSingleAttachment(params: { id: string; selected: boolean }) {
    const initialAttachments = this.batchDepartureAttachments$.getValue();

    const updatedDepartures = initialAttachments.map((batchItem) =>
      batchItem.id === params.id
        ? { ...batchItem, selected: params.selected }
        : batchItem
    );

    this.batchDepartureAttachments$.next(updatedDepartures);
  }

  public ngOnDestroy() {}

  protected getRecipientName(person: BelpostContact['person']): string {
    switch (person.type) {
      case 'individual':
        return (
          [person.last_name, person.first_name, person.second_name]
            .filter(Boolean)
            .join(' ') || '-'
        );

      default:
        return person.organization_name || '-';
    }
  }
}
